import React, { Component } from "react";

import styles from "./styles.scss";

import CSSModules from "react-css-modules";
import { Button, CircularProgress } from "@material-ui/core";
import masterRuleService from "../../services/masterRule";
import ruleService from "../../services/rules";
import importStatus from "../../services/importStatus";
import moment from "moment";


@CSSModules(styles, { allowMultiple: true })
class GeneratedChildRules extends Component {

  constructor(props) {

    super(props);
    this.state = {

      ruleId: props.match.params.ruleId,
      isBusy: true,
      isBusyFetchingNewRules: false,

      masterRule: props.masterRule,
      activeChildRules: null

    };
  }

  componentDidMount() {

    this.setState({ isBusy: true });

    try {

      let masterRulePromise = masterRuleService
        .getMasterRule(this.state.ruleId)
        .then(data => this.setState({ masterRule: data }));

      let childRulesPromise = masterRuleService
        .getChildRulesForMasterRule(this.state.ruleId)
        .then(data => this.setState({ activeChildRules: data }));

      Promise
        .all([masterRulePromise, childRulesPromise])
        .then(() => {
          this.setState({ isBusy: false });
        });


    } catch (e) {
      this.setState({
        activeChildRules: null,
        masterRule: null,
        isBusy: false
      });
    }


  }

  openLatestImport(masterRuleId) {
    importStatus.getLatestImport(masterRuleId).then((latestImport) => {
      if(latestImport) {
        window.open("/MasterRules/Import/Status/" + latestImport.ruleImportStatusId + "/Overview", "_blank");
      }
    })
  }

	openWindow(ruleInstanceId) {
    let now = moment().endOf('day').format("YYYY-MM-DD");
    let oneWeekAgo = moment().subtract(7, 'day').startOf('day').format("YYYY-MM-DD");
		window.open(
			"/Reports/" + ruleInstanceId + "/" + oneWeekAgo + "," + now, 
			"_blank");
	}

  render() {

    if (this.state.isBusy === true)
      return <div class={"center-children full-height"}><CircularProgress /></div>;

    if (this.state.masterRule == null || this.state.activeChildRules == null)
      return <div>Error loading data</div>;

    const masterRule = this.state.masterRule;

    return (

      <div>

        <div style={{display:"flex",flexDirection:"row"}}>
          <h3 class={"no-top-margin"}>{masterRule.textId}</h3>
          <div class={"latest-import-button"} onClick={() => this.openLatestImport(masterRule.masterRuleInstanceId)}>Latest Import</div>
        </div>

        {/* Active Child Rules */}
        <div className={"padding-v-1"}>
          <div styleName={"heading-with-number"}>
            <span>Active Rules</span>
            <div>{this.state.activeChildRules.length}</div>
          </div>


          {/* Contextual Text */}
          <div className={"padding-v-0"}>
            <span styleName={"info-text"}>The following child rules have already been generated from the master rule. </span>
            {masterRule.pendingModified == 0 && <span styleName={"info-text"}>There are no pending updates. </span>}
            {masterRule.pendingModified > 0 && <span styleName={"info-text"}>{masterRule.pendingModified} of these rules are pending updates. </span>}
          </div>

          {this.state.activeChildRules.length > 0 &&
            <table class={"lightweight-table"}>
              <thead>
              <tr>
                <th>Group</th>
                <th>Run Status</th>
                <th>Rule Status</th>
                <th>Last Ping</th>
                <th>Last Finished</th>
                <th>Waiting On</th>
                <th>Pending Update</th>
              </tr>
              </thead>
              <tbody>
              {this.state.activeChildRules.map((rule, i) => {
                return (
                  <tr key={i} className={"active-child-rule-container"} onClick={() => { this.openWindow(rule.ruleInstanceId) }}>
                    <td>{rule.name.split("___")[1]}</td>
                    <td>{rule.isRunning ? "Running" : "No Data"}</td>
                    <td>{ruleService.ruleStatusIntToText(rule.lastRunStatus)}</td>
                    <td>{rule.lastPingTimeUtc ? rule.lastPingTimeUtc.toLocaleString() : "Never" }</td>
                    <td>{rule.lastFinishedUtc ? rule.lastFinishedUtc.toLocaleString() : "Never"}</td>
                    <td>{rule.waitingOn}</td>
                    <td>{masterRule.pendingModified > 0 && masterRule.pendingModifiedTextIds.includes(rule.textId) ? "Yes" : "No"}</td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          }

        </div>


        {/* Pending Child Rules */}
        <div class={"padding-v-1"}>
          <div styleName={"heading-with-number"}>
            <span>Pending Rules</span>
            <div>{masterRule.pendingNew}</div>
          </div>

          {/* Contextual Text */}
          <div className={"padding-v-0"}>
            {masterRule.pendingNew == 0 && <span styleName={"info-text"}>There are no new child rules to be generated at this time. </span>}
            {masterRule.pendingNew > 0 && <span styleName={"info-text"}>There are {masterRule.pendingNew} child rules pending generation. </span>}
          </div>


          {masterRule.pendingNew > 0 && <div>
            <div style={{marginTop: "1rem"}}>
              {masterRule.pendingNewTextIds.map((textId, i) => {
                return (
                  <div>
                    {textId.split("___")[1]}
                  </div>
                );
              })
              }
            </div>
          </div>}
        </div>



      </div>

    );
  }

}

export default GeneratedChildRules;



// WEBPACK FOOTER //
// ./src/components/GeneratedChildRules/GeneratedChildRules.js